<template>
  <div class="pm-dialog-port-vessel">

    <vue-simple-suggest
      v-model="selectedVesselInput"
      :list="masterPortVesselList"
      :display-attribute="'name'"
      :value-attribute="'id'"
      :filter-by-query="true"
      @select="onSelectSuggest"
    />

    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");
const { mapState: mapStateOfPortMaster } = createNamespacedHelpers("portMaster");
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const PortMasterVesselMasterApi = AiseaApiFactory.get("portMasterVesselMaster");
import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css'; // Optional CSS
import 'mapbox-gl/dist/mapbox-gl.css';


export default {
  props: {
    showPopup: { type: Boolean, required: true },
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true},
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  components: {
    VueSimpleSuggest
  },
  data() {
    return {
      selectedVessel: null,
      selectedVesselInput: null,
      masterPortVesselList: [],
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapStateOfPortMaster({
      selectedPort: state => state.selectedPort,
    }),
    ...mapState({
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    enableSave() {
      return this.selectedVessel && this.selectedVessel.id && this.selectedVessel.name === this.selectedVesselInput;
    },
  },
  methods: {
    initData() {
      this.selectedVessel = !(this.valueMap && this.valueMap.enterprisePortVessel) ? null
        : {
            id: this.valueMap.enterprisePortVessel.id,
            name: this.valueMap.enterprisePortVessel.name,
          };
      this.selectedVesselInput = this.selectedVessel ? this.selectedVessel.name : null;
    },
    onSelectSuggest(selectedVessel) {
      this.selectedVessel = selectedVessel;
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey + '#id'] = this.selectedVessel ? this.selectedVessel.id : null;
      this.$emit('updateValue', this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  async mounted() {

    const res = await PortMasterVesselMasterApi.fetch(this.selectedPort.id);
    this.masterPortVesselList = ( res && res.data ? res.data.vessels : [] ).map(x => {
      return {
        id: x.id,
        name: x.name,
      };
    });

    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-port-vessel {
  .pm-select {
    margin: 15px 0px;
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
  .vue-simple-suggest.designed .suggestions .suggest-item {
    &.selected {
      background-color: $pm-blue !important;
    }
    &.hover {
      background-color: $pm-green !important;
    }
  }
}
</style>

